import { render, staticRenderFns } from "./previewFormModal.vue?vue&type=template&id=08fc1279&scoped=true"
import script from "./previewFormModal.vue?vue&type=script&lang=js"
export * from "./previewFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fc1279",
  null
  
)

export default component.exports